import React from 'react';
import Pagination from 'react-bootstrap/Pagination';
import { useInterface } from '../../context/InterfaceProvider';

export default function SimpleCardsPagination({ pages, currentPage, onPageChange }) {
  const { version } = useInterface();
  if (version !== 'simple') {
    return <Pagination className="simple-neon-panel">{pages.map(number => (
      <Pagination.Item key={number} active={number === currentPage} onClick={() => onPageChange(number)}>{number}</Pagination.Item>
    ))}</Pagination>;
  }

  const last = pages.length;
  if (!last) return null;
  const visible = last <= 5 ? pages
    : currentPage <= 3 ? [1, 2, 3, 'end-gap', last]
    : currentPage >= last - 2 ? [1, 'start-gap', last - 2, last - 1, last]
    : [1, 'start-gap', currentPage, 'end-gap', last];

  return (
    <Pagination className="simple-neon-panel" aria-label="Card pages">
      <Pagination.Prev aria-label="Previous page" disabled={currentPage <= 1} onClick={() => onPageChange(Math.max(1, currentPage - 1))} />
      {visible.map(number => typeof number === 'number' ? (
        <Pagination.Item key={number} aria-label={`Page ${number}`} aria-current={number === currentPage ? 'page' : undefined} active={number === currentPage} onClick={() => onPageChange(number)}>{number}</Pagination.Item>
      ) : <Pagination.Ellipsis key={number} className="simple-pagination-gap" disabled />)}
      <Pagination.Next aria-label="Next page" disabled={currentPage >= last} onClick={() => onPageChange(Math.min(last, currentPage + 1))} />
    </Pagination>
  );
}
